import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFocusSquare"><Path d="M3 3H9V5H5V9H3V3Z" fill="currentColor"/><Path d="M15 3H21V9H19V5H15V3Z" fill="currentColor"/><Path d="M5 15V19H9V21H3V15H5Z" fill="currentColor"/><Path d="M21 15V21H15V19H19V15H21Z" fill="currentColor"/><Path d="M16 8H8V16H16V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusSquare;
